<template>
    <form-row title="How many extensions?" label_class="self-start mt-3">
        <div class="flex flex-1 flex-col sm:flex-row items-start">
            <div class="flex-none w-16">
                <input-text
                    name="entitlement_extend_count"
                    v-model="entitlement_extend_count"
                    :read_only="read_only"
                />
            </div>

            <div class="pl-10">
                <div v-for="(extension, index) in extensions">
                    <input-date
                        class="mb-4"
                        :name="'entitlement_extend_dates[' + index + ']'"
                        v-model="entitlement_extend_dates[index]"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            entitlement_extend_count: this.commercial.entitlement_extend_count,
            entitlement_extend_dates: this.commercial.entitlement_extend_dates || [],
        }
    },

    computed: {
        extensions() {
            return parseInt(this.entitlement_extend_count) || 0;
        },
    },
}
</script>
